import { jsxs as n, jsx as a } from "react/jsx-runtime";
import { clsx as d } from "clsx";
import { forwardRef as g, useRef as k, useEffect as N } from "react";
import s from "./Checkbox.module.css.js";
import { useInputErrorMessages as I } from "../InputErrorMessage/useInputErrorMessages.js";
import { useMergeRefs as M } from "../../utils/hooks/useMergeRefs.js";
import { InputErrorMessage as R } from "../InputErrorMessage/InputErrorMessage.js";
const j = g(
  ({ children: t, checked: i, indeterminate: o, disabled: m, error: l, errorIds: p, className: f, ...u }, x) => {
    const { isInvalid: h, errorMessages: e } = I(l), c = k(null), b = M(x, c);
    return N(() => {
      const r = c.current;
      r && (r.indeterminate = !!o);
    }, [o]), /* @__PURE__ */ n("div", { className: d(s.container, f), children: [
      /* @__PURE__ */ n("label", { className: s.checkboxLabel, children: [
        /* @__PURE__ */ a(
          "input",
          {
            className: s.checkboxInput,
            ...u,
            ref: b,
            type: "checkbox",
            checked: i,
            "aria-checked": o ? "mixed" : i,
            disabled: m,
            "aria-invalid": h,
            "aria-errormessage": e.length > 0 ? e.map((r) => r.id).join(" ") : p
          }
        ),
        t && /* @__PURE__ */ a("span", { className: s.labelText, children: t })
      ] }),
      e.length > 0 && /* @__PURE__ */ a(R, { children: e })
    ] });
  }
);
j.displayName = "Checkbox";
export {
  j as Checkbox
};
//# sourceMappingURL=Checkbox.js.map
